<template>
  <div class="toggle-switch-button">
    <label class="uk-toggle-switch">
      <input :checked="modelValue === 1 || modelValue === true" type="checkbox" @change="toggleValue">
      <span class="uk-toggle-slider"/>
    </label>
    <p class="toggle-switch-title">{{ title }}</p>
  </div>

</template>

<script>
export default {
  props: {
    value: {
      type: [Boolean, Number],
    },
    title: {
      type: String,
      default: ''
    }
  },

  /*
    NOT: Projede tutulan veriler bazen 1 ve 0 olarak ifade edilebiliyor. Bu durumda, veri değişimleri ile uğraşmak yerine
    toggle-button yerine bu komponent kullanılabilir.
  */

  computed: {
    modelValue: {
      get() {
        // Handle both boolean and number cases
        if (this.value === 1) {
          return 1;
        } else if (this.value === 0) {
          return 0;
        } else {
          return this.value === true ? true : false;
        }
      },
      set(newValue) {
        // Emit the new value as 1 or 0 for number, or true/false for boolean
        if (typeof this.value === 'boolean') {
          this.$emit("input", newValue ? true : false);
        } else {
          this.$emit("input", newValue ? 1 : 0);
        }
      },
    },
  },
  methods: {
    toggleValue(event) {
      // Emit 1 or 0 if the value is a number
      // Emit true or false if the value is a boolean
      if (typeof this.value === 'boolean') {
        this.$emit("input", event.target.checked);
      } else {
        this.$emit("input", event.target.checked ? 1 : 0);
      }
    },
  },
};
</script>

<style>
.toggle-switch-title {
  margin-top: 4px;
  margin-left: 4px;
  font-weight: bold;
}
.toggle-switch-button {
  display: flex;
  align-items: center;
}

.uk-toggle-switch {
  position: relative;
  display: inline-block;
  width: 50px;
  height: 24px;
}

.uk-toggle-switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.uk-toggle-slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #BFCBD9;
  border-radius: 34px;
  transition: 0.3s;
}

.uk-toggle-slider:before {
  position: absolute;
  content: "";
  height: 18px;
  width: 18px;
  left: 3px;
  bottom: 3px;
  background-color: white;
  border-radius: 50%;
  transition: 0.3s;
}

input:checked + .uk-toggle-slider {
  background-color: #8a4ed8;
}

input:checked + .uk-toggle-slider:before {
  transform: translateX(26px);
}
</style>
